import React from 'react';
import AboutUsSection from '../unit/unit-section';

const PatientInformation = (props) => {
  return (
    <div className="patient-information">
      {props.PatientInformation && (
        <AboutUsSection>
          {props.PatientInformation.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </AboutUsSection>
      )}
    </div>
  );
};

export default PatientInformation;
